export default "/images/ba1ec8ffd24dee2922ab41e146a57fe9.avif";